import React from "react";
import announcementImage from "../asset/announcements.png";

const Announcements = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">

      <div className="text-center">
              <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1f4774] dark:text-white mb-10 text-center sm:text-left">
          Announcements
        </h1>
        <img 
          src={announcementImage} 
          alt="Announcements Coming Soon"
          className="w-full max-w-[200px] sm:max-w-[250px] md:max-w-[300px] h-auto mx-auto"
        />
      </div>
    </div>
  );
};

export default Announcements;